(function () {
    'use strict';

    angular
        .module('app.reports')
        .controller('EventCompletionsReportController', EventCompletionsReportController);

    EventCompletionsReportController.$inject = ['$window', 'common', 'dataservice', 'carousel.dialog', 'ReportFileBuilder'];
    /* @ngInject */
    function EventCompletionsReportController($window, common, dataservice, carouselDialog, reportFileBuilder) {
        var vm = this;
        vm.title = 'Event Completions Report';
        vm.filters = {
            fromDate: new Date(),
            toDate: new Date()
        };
        vm.items = [];
        vm.displayedItems = [].concat(vm.items);
        vm.openDatePicker = openDatePicker;
        vm.exportToExcel = exportToExcel;
        vm.exportToPdf = exportToPdf;
    
        vm.generated = false;
        vm.dpStatus = {
            fromDateOpen: false,
            toDateOpen: false
        };

        vm.generate = generate;

        activate();

        function activate() {
            vm.filters.forDate = new Date();
            var promises = [];
            return common.$q.all(promises).then(function (data) {
                common.logger.info('Activated ' + vm.title + ' View');
            }, function (error) { });
        }


        function exportToExcel(id) {
            reportFileBuilder.exportToExcel("Events Completion Report", id);
        }

        

        function exportToPdf(id) {
            reportFileBuilder.exportToPdf("Events Completion Report", id, vm.filters);
        }

        function openDatePicker(isStart) {
            if (isStart) {
                vm.dpStatus.fromDateOpen = true;
                vm.dpStatus.toDateOpen = false;
            }
            else {
                vm.dpStatus.fromDateOpen = false;
                vm.dpStatus.toDateOpen = true;
            }

        }

      
        function generate() {
            vm.filters.fromDateLocalString = moment(vm.filters.fromDate).format("YYYY-MM-DD");
            vm.filters.toDateLocalString = moment(vm.filters.toDate).format("YYYY-MM-DD");

            return dataservice.query('api/Reports/EventCompletions', vm.filters).then(function (response) {
                vm.items = response.data;
                vm.generated = true;
                return vm.items;
            }, function (error) { });

        }

    }
})();
